// extracted by mini-css-extract-plugin
module.exports = {"trustpilot":"Trustpilot_trustpilot__VMOJ5"};